import { render } from "./DunningList.vue?vue&type=template&id=27df5e95"
import script from "./DunningList.vue?vue&type=script&lang=js"
export * from "./DunningList.vue?vue&type=script&lang=js"

import "./DunningList.vue?vue&type=style&index=0&id=27df5e95&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__